import { ROULETTE_NUMBER } from './types';

export const setRouletteNumber = num => dispatch => {
    dispatch({
        type: ROULETTE_NUMBER,
        payload: num
    })
};
